var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-4",attrs:{"icon":""},on:{"click":_vm.switchShowMode}},[_c('v-icon',[_vm._v("mdi-brightness-4")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }